import React from 'react';
import './GroupStatusBadge.css';

const BADGES = {
  system: { label: 'System', title: 'Feste Systemgruppe – nicht archivier- oder löschbar' },
  archived: { label: 'Archiviert', title: 'Wird in Auswahllisten nicht mehr angeboten' },
  role: { label: 'Rolle', title: 'Feste Rolle – unabhängig von der Gruppe, nicht löschbar' },
};

// Small uppercase pill next to a group or role name (list rows, editor header).
function GroupStatusBadge({ kind }) {
  const badge = BADGES[kind];
  if (!badge) return null;
  return <span className={`groupStatusBadge is-${kind}`} title={badge.title}>{badge.label}</span>;
}

export default GroupStatusBadge;
